import pageNotFoundImg from './images/undraw_page_not_found_su7k.svg';

const images = {
  pageNotFoundImg
};

export default images;
